export default "__VITE_ASSET__iMi4l1$g__"